<template>
	<header class="header-wapper header-sticky">
		<div class="header-wapper-container">
			<div class="container">
				<div class="header-navbar">
					<div class="logo-img">
						<a href="index.html">
                            <img src="@/assets/images/logo.webp" alt="logo">
                        </a>
					</div>
					<div class="exch-header-content">
						<router-link to="/" class="exch-page-head-btn-close" ref="close_button">
                            <span class="fa fa-close"></span>
                        </router-link>
					</div>
				</div>
			</div>
		</div>
		<div class="pd-12 top-border-bottom">
			<a class="exch-breadcrumb-heading-sec" @click="$router.go(-1)">
                <img src="@/assets/images/back.webp" alt="back">
				<h5>{{ $t('wallet', 'Wallet') }}</h5>
            </a>
		</div>
	</header>
	<div class="exch-deposit-wrapper">
		<div class="mr-row-sec">
			<div class="exch-header-account-wrapper">
				<div class="exch-top-account-profile-wrapper">
					<div class="exch-top-account-profile-upper-div">
						<div class="exch-top-account-profile-upper-div-left" v-if="$auth?.user">
                            <span class="exch-top-account-left-balanced">{{ $auth?.user?.balance }}</span>
							<p class="xs-bd-font">{{ $t('your-total-balance', 'Your Total Balance') }}</p>
						</div>
						<div class="exch-top-account-profile-upper-div-right">
                            <img src="@/assets/images/profile-card-wallet.webp" alt="profile-card-wallet" style="width: 3.5rem; height: 3.01rem;">
                        </div>
					</div>
				</div>
				<div class="exch-wallet-deposit-box-wrapper">
					<router-link :to="{ name: 'wallet-withdraw' }" class="cursor-pointer">
						<div class="exch-wallet-box-icn">
                            <img src="@/assets/images/withdraw.webp">
                        </div>
                        <span class="sm-bd-font">{{ $t('wallet-withdraw', 'Wallet Withdraw') }}</span>
                    </router-link>
					<router-link :to="{ name: 'wallet-deposit' }" class="green-bg cursor-pointer">
						<div class="exch-wallet-box-icn">
                            <img src="@/assets/images/deposit.webp">
                        </div>
                        <span class="sm-bd-font">{{ $t('wallet-deposit', 'Wallet Deposit') }}</span>
                    </router-link>
				</div>
				<ul class="exch-top-account-menu-box-wrapper">
					<li>
						<router-link to="/wallet-history">
							<div>
                                <img src="@/assets/images/profile-card-wallet.webp" alt="profile-card-wallet">
                                <span class="sm-bd-font">{{ $t('wallet-history', 'Wallet History') }}</span>
                            </div>
                            <span class="exch-list-right-arrow">
                                <span class="fa-solid fa-chevron-right"></span>
                            </span>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "Wallet",
    inject: ['walletHeader'],
}
</script>